import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ElectoralLiteracy/2024/Classleader/1.jpg';
// import p2 from 'assests/Photos/ElectoralLiteracy/2024/Classleader/2.jpg';
// import p3 from 'assests/Photos/ElectoralLiteracy/2024/Classleader/3.jpg';
// import p4 from 'assests/Photos/ElectoralLiteracy/2024/Classleader/4.jpg';



import { Typography } from '@mui/material';
import Container from 'components/Container';
import SidebarArticles from 'views/ClassAssembly2023';
import { Sidebar } from 'views/ElectoralLiteracy2023/components';

import Archive2023 from '../ElectoralLiteracy2023/components/Archive2023';
import Sidebar2026 from '../ElectoralLiteracy2023/components/Sidebar/Sidebar2026';



const ClassLeader6to82026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_url_2026: '' });
useEffect(() => {
  fetch('/config.json')
    .then(response => response.json())
    .then(data => setConfig(data))
    .catch(error => console.error('Error fetching config:', error));
}, []);
const p1 = `${config.base_image_url_2026}/home/events-activities/club/electoral-literacy/election/1.webp`;
const p2 = `${config.base_image_url_2026}/home/events-activities/club/electoral-literacy/election/2.webp`;
const p3 = `${config.base_image_url_2026}/home/events-activities/club/electoral-literacy/election/3.webp`;
const p4 = `${config.base_image_url_2026}/home/events-activities/club/electoral-literacy/election/4.webp`;


    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
   
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                               REPORT ON ELECTION OF CLASS LEADERS (6 TO 8) 2026-27
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 6 to 8 Date: 30 June 2026

                                </Typography>
                                <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                 {/* <br /> */}
“Somewhere inside all of us is the power to change the world”
                            </Typography>


                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
The Elections for class leaders of grades 6 to 8 was conducted on 30th June 2026, in a democratic manner by ballot paper method. The candidates had campaigned before the day of election during the CTP period. The election guidelines and code of conduct were announced in advance by the President and Vice-President of the Electoral Club to ensure a fair and transparent process. Six polling booths were set up to facilitate smooth voting. Student executives were assigned various responsibilities and efficiently managed the entire election process. Their duties included verifying voters' ID cards, issuing ballot papers, and applying indelible ink on the left index finger of each voter after casting their vote.                     
               <br></br>
The activity provided students with a practical understanding of the democratic electoral process and the procedures followed during an election. It served as an excellent experiential learning opportunity of the election. The results were announced in the class by the class teacher.
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                      The Ballot is stronger than bullet
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 600}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box>
                        <Box marginBottom={4}>
                            <Archive2023/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default ClassLeader6to82026;